import { Participant } from '@app/models'

export const isB2C = (participant: Participant | null) => {
  if (participant?.role === 'MainBuyerOrRenter' || participant?.role === 'BuyerOrRenter') return true
  return false
}